import React, { useState, useEffect } from "react";
import {
  IonList,
  IonItem,
  IonLabel,
  IonBadge,
  IonIcon,
  IonRefresherContent,
  IonRefresher,
  IonContent,
} from "@ionic/react";
import { useIntl } from "react-intl";
import {
  checkboxOutline,
  calendarOutline,
  warningOutline,
  medicalOutline,
} from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { setVisitsFilter, setSummary } from "../../visits/visitsSlice";
import { setPatientsFilter } from "../../patients/patientsSlice";
import { useQuery } from "react-query";
import { getVisitsSummary } from "../../../api/server";
import { useHistory } from "react-router-dom";
import { chevronDownCircleOutline } from "ionicons/icons";
import moment from "moment";

const Visits = (props) => {
  const { setFetching } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const history = useHistory();
  const { activeMonth } = useSelector((state) => state.visits);
  const { scopePrefix, profile, activeBranch } = useSelector(
    (state) => state.auth
  );
  const { activeEmployee } = useSelector((state) => state.employee);
  const [refresherEvent, setRefresherEvent] = useState(null);
  const [counter, setCounter] = useState(0);
  const from = moment(activeMonth).startOf("month").format();
  const to = moment(activeMonth).endOf("month").format();

  const params = {
    query: {
      from,
      to,
      branch: activeBranch,
    },
    scopePrefix,
    employeeId: profile.associated_employee_id,
  };

  const { data, isFetching } = useQuery(
    [params, history.location, counter, activeEmployee.id],
    async () => {
      const result = await getVisitsSummary(params);
      dispatch(setSummary(result.data));
      return result.data;
    },
    {
      keepPreviousData: true,
      staleTime: 0,
      enabled:
        profile.associated_employee_id !== null &&
        history.location.pathname === "/app/home",
    }
  );
  const {
    all,
    completed,
    missed,
    scheduled,
    needsApproval,
    long_hospitalizations,
  } = data || {};

  useEffect(() => {
    if (!isFetching && refresherEvent) {
      refresherEvent.detail.complete();
      setRefresherEvent(null);
    }
    setFetching(isFetching);
  }, [isFetching]);

  const doRefresh = (event) => {
    setRefresherEvent(event);
    setCounter(counter + 1);
  };
  return (
    <IonContent>
      <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
        <IonRefresherContent
          pullingIcon={chevronDownCircleOutline}
          refreshingSpinner="lines"
        ></IonRefresherContent>
      </IonRefresher>

      <IonList
        style={{
          borderTop: "1px solid #a8a8a8",
          borderBottom: "1px solid #a8a8a8",
        }}
      >
        <IonItem
          onClick={() => {
            dispatch(setVisitsFilter("all"));
          }}
          key={"all"}
          button
          routerLink={`/app/visits`}
          // routerAnimation={"root"}
          // routerDirection={"root"}
        >
          <IonIcon icon={calendarOutline} slot="start" />
          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.all_visits",
            })}
          </IonLabel>
          <IonBadge color="light" slot="end">
            {all}
          </IonBadge>
        </IonItem>

        <IonItem
          onClick={() => {
            dispatch(setVisitsFilter("done"));
          }}
          key={"approved_visits"}
          button
          routerLink={`/app/visits`}
        >
          <IonIcon icon={calendarOutline} slot="start" />
          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.approved_visits",
            })}
          </IonLabel>
          <IonBadge color="light" slot="end">
            {completed}
          </IonBadge>
        </IonItem>
        <IonItem
          onClick={() => {
            dispatch(setVisitsFilter("scheduled"));
          }}
          key={"scheduled_visits"}
          button
          routerLink={`/app/visits`}
        >
          <IonIcon icon={calendarOutline} slot="start" />

          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.scheduled_visits",
            })}
          </IonLabel>
          <IonBadge color="light" slot="end">
            {scheduled}
          </IonBadge>
        </IonItem>
        <IonItem
          onClick={() => {
            dispatch(setVisitsFilter("missing"));
          }}
          key={"missing_visits"}
          button
          routerLink={`/app/visits`}
        >
          <IonIcon icon={warningOutline} slot="start" />

          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.missing_visits",
            })}
          </IonLabel>
          <IonBadge color="danger" slot="end">
            {missed}
          </IonBadge>
        </IonItem>
        <IonItem
          onClick={() => {
            dispatch(setPatientsFilter("long_hospitalized"));
          }}
          key={"long_hospitalized_visits"}
          button
          routerLink={`/app/patients`}
        >
          <IonIcon icon={medicalOutline} slot="start" />

          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.long_hospitalized_visits",
            })}
          </IonLabel>
          <IonBadge color="light" slot="end">
            {long_hospitalizations}
          </IonBadge>
        </IonItem>
        <IonItem
          onClick={() => {}}
          key={"unapproved_visits"}
          button
          lines="none"
          routerLink={`/app/controllerVisits`}
        >
          <IonIcon icon={checkboxOutline} slot="start" />
          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.unapproved_visits",
            })}
          </IonLabel>
          <IonBadge color="light" slot="end">
            {needsApproval}
          </IonBadge>
        </IonItem>
      </IonList>
    </IonContent>
  );
};

export default Visits;
